// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { API_BASE_URL } from "../../../../utils/index";
// import BackArrow from "../../../../components/MinorComponents/BackArrow";
// import { Modal } from "react-bootstrap";
// function SubsubCategorysDetial(show, handleClose,) {
//   const { _id } = useParams();
//   const [subCategory, setSubCategory] = useState({});
//   const [propertytype, setProperty] =useState({})
//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/singlesubcategory/${_id}`)
//       .then((response) => {
//         setSubCategory(response.data.data);
//         setProperty(response.data.data.category);
//         console.log(response.data.data, "singlesubcategory");
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, []);

//   return (
//     // <div className=" text-center mt-5 card w-50 m-auto" id="viewpagesub">

//     //   <h4 className="mt-4">Property Type Details</h4>
     

//     //  <div className="d-flex">
      
//     //  </div>
//     //  <div className="d-flex m-auto">

//     //   <h6 className="fs-5"> Type:</h6>
//     //   <p className="ms-2">{propertytype.categoryname}</p>
   
//     //  </div>
   
//     //  <div className="d-flex m-auto">

//     //   <h6 className="fs-5"> Property Type:</h6>
//     //   <p className="ms-2">{subCategory.subcategoryname}</p>
   
//     // </div>
     
     

//     //   <BackArrow path="/subCategory" /> 
        
//     //      Back
        
//     //   </div>
//     <Modal show={show} onHide={handleClose}>
//     <Modal.Header closeButton>
//       <Modal.Title className="text-center">
//         <h5 className="text-center ms-5">Property Type Details</h5>
//       </Modal.Title>
//     </Modal.Header>
//     <Modal.Body>
//       <h6 className="fs-5">Type:</h6>
//       <p>{propertytype?.categoryname}</p>
//       <h6 className="fs-5">Property Type:</h6>
//       <p>{subCategory?.subcategoryname}</p>
     
//     </Modal.Body>
//     <Modal.Footer className="m-auto">
//       <BackArrow path="/subcategorys" /> Back
//     </Modal.Footer>
//   </Modal>
//   );
// }

// export default SubsubCategorysDetial;
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../../utils/index";
import BackArrow from "../../../../components/MinorComponents/BackArrow";
import { Modal } from "react-bootstrap";

function SubsubCategorysDetial({ show, handleClose, categoryId }) { // Destructure props correctly
  // const { _id } = useParams();

  const [subCategory, setSubCategory] = useState({});
  const [propertytype, setProperty] = useState({});
  console.log( categoryId,"EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE")
  useEffect(() => {
      axios
          .get(`${API_BASE_URL}/singlesubcategory/${categoryId}`)
           .then((response) => {
          
             setSubCategory(response.data.data);
            setProperty(response.data.data.category);
            console.log(response.data.data, "singlesubcategory");
          })
           .catch((error) => {
          console.error(error);
           });
      }, [categoryId]);
  return (
    <Modal show={show} onHide={handleClose}>
       <Modal.Header className="text-center" >
          <Modal.Title className="m-auto fw-bold " >
           
           Property Type Details
          </Modal.Title>
        </Modal.Header>
      <Modal.Body>
      <div className="">
        <div className=" background p-2 bg-info  border-start-0 rounded text-center">

        <h6 className="fs-5  " >Type  </h6>
        <span className="fs-5 text-white ">{propertytype.categoryname}</span>
        </div>
        <div className="background p-2   bg-warning border-start-0 rounded text-center mt-3">

        <h6 className="fs-5  ">Property Type  </h6>
        <span className="fs-5 text-white">{subCategory.subcategoryname}</span>
        </div>
      </div>
        
        <div className="d-flex m-auto">  
</div>
      </Modal.Body>
      <Modal.Footer className="m-auto    ">
        <span onClick={handleClose} className="">

        <BackArrow className="" /> Back
        </span>
      </Modal.Footer>
    </Modal>
  );
}

export default SubsubCategorysDetial;
